export { SimpleHeaderLayoutMap } from './simple-header-layout';
